import React from 'react'
import FooterApi from 'utils/FooterApi'
import BreadcrumbComponent from 'components/Breadcrumbs'
import { MainWrapper, AboutUsWrapper, ContentWrapper } from 'styles/FooterLinks/AboutUsPage'

const ShippingPolicy = () => {
  const { data } = FooterApi('shippingpolicy')
  return (
    <MainWrapper>
      <AboutUsWrapper>
        <BreadcrumbComponent title="Shipping Policy" />
        <ContentWrapper>
          <div dangerouslySetInnerHTML={{ __html: data?.shippingpolicy }} />
        </ContentWrapper>
      </AboutUsWrapper>
    </MainWrapper>
  )
}

export default ShippingPolicy
